import React, { useState } from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faLinkedinIn, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';


const Footer = () => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterMessage, setNewsletterMessage] = useState('');
  
  const currentYear = new Date().getFullYear();
  // const handleNewsletterSubmit = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const response = await fetch('http://127.0.0.1:5000/subscribe', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ email: newsletterEmail }),
  //     });
  //     const result = await response.text();
  //     setNewsletterMessage(result);
  //   } catch (error) {
  //     setNewsletterMessage('Subscription added for your mail.');
  //   }
  // };

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();
    setNewsletterMessage('Subscribing...');
  
    // Simulating a successful subscription
    setTimeout(() => {
      setNewsletterMessage('Subscription successful! Thank you for subscribing.');
  
      // Clear the input field after a delay (e.g., 2 seconds)
      setTimeout(() => {
        setNewsletterMessage('');
        setNewsletterEmail('');
      }, 2000);
    }, 1000);
  };
  

  return (
    <footer className="footer">
        <div className="footer-newsletter">
        <h3>Subscribe to Our Newsletter</h3>
        <form id="newsletter-form" onSubmit={handleNewsletterSubmit}>
          <input
            type="email"
            id="newsletter-email"
            name="email"
            placeholder="Enter your email"
            value={newsletterEmail}
            onChange={(e) => setNewsletterEmail(e.target.value)}
            required
          />
          <button type="submit">Subscribe</button>
          <p id="newsletter-message">{newsletterMessage}</p>
        </form>
      </div>
      <div className="footer-content">
        <div className="footer-contact">
          <h3>Contact Us</h3>
          <p><FontAwesomeIcon icon={faEnvelope} /> <a href="mailto:contact@example.com">sales@innometrixtechub.com</a></p>
          <p><FontAwesomeIcon icon={faPhone} /> +91 9043993677</p>
          <p>
          129/8a6, Attur Bypass Road, Seelanaickenpatti, Salem</p>
        </div>

        <div className="footer-nav">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="https://www.innometrixtechub.com/about/"  target="_blank" rel="noopener noreferrer" >About Us</a></li>
            <li><a href="https://www.innometrixtechub.com/it-and-cyber-consulting-services/" target="_blank" rel="noopener noreferrer"> Our Services</a></li>
            <li><a href="https://www.innometrixtechub.com/blog/" target="_blank" rel="noopener noreferrer" >Blog</a></li>
            <li><a href="https://www.innometrixtechub.com/contact/" target="_blank" rel="noopener noreferrer">Contact Us</a></li>       
          </ul>
        </div>

        <div className="footer-social">
          <h3>Follow Us</h3>
          <a href="https://www.facebook.com/people/Innometrix-Techub/61555544704880/" className="social-icon" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="https://x.com/i/flow/login?redirect_after_login=%2FInnometriXTecHb" className="social-icon" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          <a href="https://linkedin.com/in/innometrix-techub-ba3b232a8" className="social-icon" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
          <a href="https://www.instagram.com/innometrix_techub/" className="social-icon" target="_blank" rel="noopener noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
     </div>
     
      <hr className="separator" />
      <div className="footer-bottom">
         {/* <ThemeToggle /> */}
        <p>© {currentYear}  InnometriX Techub. All rights reserved.</p>
        {/* <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a> */}
      </div>
    </footer>
  );
};

export default Footer;
